import Environment from './Environment';
/**
 * Logs to the console if the environment is test and not running in jest
 */
export const devLog = (...input: any[]) => {
  if (Environment.isTest && !Environment.isRunningInJest()) {
    console.log(...input);
  }
};
